module.exports = __webpack_public_path__ + "img/payment-ach.14ea1c16.svg";